import { getRandomInt } from '~/bootcamp/Activities/Fractions/Fractions.utils'

const VARIABLES = ['a', 'b', 'c', 'd', 'x', 'y', 'z']

export const RANGE_DATA: RangeDataModel = {
  1: {
    minInteger: 2,
    maxInteger: 10,
    minCoefficient: 1,
    maxCoefficient: 10,
    integerCount: 1,
    maxHistoryLength: 7,
  },
  2: {
    minInteger: -10,
    maxInteger: 10,
    minCoefficient: -10,
    maxCoefficient: 10,
    integerCount: 1,
    maxHistoryLength: 7,
  },
  3: {
    minInteger: -5,
    maxInteger: 5,
    minCoefficient: -5,
    maxCoefficient: 5,
    integerCount: 2,
    maxHistoryLength: 7,
  },
}

interface RangeDataModel {
  [key: number]: RangeItemModel
}

interface RangeItemModel {
  minInteger: number
  maxInteger: number
  integerCount: number
  minCoefficient: number
  maxCoefficient: number
  maxHistoryLength: number
}

export interface MultCoefficient1ActivityDataModel {
  variable: string
  integers: number[]
  coefficient: number
  answer: number
  equationString: string
  maxHistoryLength: number
}

export function generateMultCoefficient1ActivityData(
  difficultyLevel: number,
  taskHistory: string[],
): MultCoefficient1ActivityDataModel {
  const range = RANGE_DATA[difficultyLevel]
  const variable = VARIABLES[getRandomInt(0, VARIABLES.length - 1)]
  const coefficient = getRandomInt(range.minCoefficient, range.maxCoefficient, [0])
  const integers: number[] = []
  let answer = coefficient
  // eslint-disable-next-line
  for (let i = 0; i < range.integerCount; i++) {
    integers[i] = getRandomInt(range.minInteger, range.maxInteger, [0, 1, -1, ...integers])
    answer *= integers[i]
  }
  const equationString = variable + coefficient + integers[0]
  if (taskHistory.includes(equationString)) {
    return generateMultCoefficient1ActivityData(difficultyLevel, taskHistory)
  }
  return { variable, integers, coefficient, answer, equationString, maxHistoryLength: range.maxHistoryLength }
}
